module.exports = __webpack_public_path__ + "static/media/linha-site.991e81e8.svg";